import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useBackerApi } from '../../api';
import { backerKeys } from '../../query-key-factory';

const useConsumerUnsubscribeToList = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const deleteRequest = async ({
    causeId,
    listId,
    token,
  }: {
    causeId?: string;
    listId: string;
    token?: string;
  }) => {
    const queryParams = new URLSearchParams();
    if (causeId) queryParams.set('cause_id', causeId);
    if (token) queryParams.set('token', token);

    const { data } = await BackerApi.delete<{ status: string }>(
      `/consumer/lists/${listId}?${queryParams.toString()}`
    );
    return data;
  };

  return useMutation({
    mutationFn: deleteRequest,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: backerKeys.consumer.lists.all });
    },
  });
};

export { useConsumerUnsubscribeToList };
